module.exports = __webpack_public_path__ + "8d82fa9eea94e107d937a1dbf0a2ee8d.svg";